// ─── Crisis resources by country code ────────────────────────────────────────
// Each country has: name, resources array with { name, number, available, type }
// type: "call" | "sms" | "chat" | "whatsapp"

export const CRISIS_RESOURCES = {

  // ── Africa ──────────────────────────────────────────────────────────────────
  ZA: {
    country: "South Africa",
    flag: "🇿🇦",
    resources: [
      { name: "SADAG (Depression & Anxiety)", number: "0800 456 789", available: "24/7", type: "call", free: true },
      { name: "SADAG SMS Line", number: "31393", available: "24/7", type: "sms", free: true },
      { name: "Suicide Crisis Line", number: "0800 567 567", available: "24/7", type: "call", free: true },
      { name: "Lifeline South Africa", number: "0861 322 322", available: "24/7", type: "call", free: false },
    ],
  },
  NG: {
    country: "Nigeria",
    flag: "🇳🇬",
    resources: [
      { name: "NPSCAN Crisis Line", number: "0800 800 2000", available: "24/7", type: "call", free: true },
      { name: "Mentally Aware Nigeria", number: "+234 806 210 6493", available: "Mon-Fri 9am-5pm", type: "call", free: false },
    ],
  },
  KE: {
    country: "Kenya",
    flag: "🇰🇪",
    resources: [
      { name: "Befrienders Kenya", number: "+254 722 178 177", available: "24/7", type: "call", free: false },
      { name: "Niskize Helpline", number: "0900 620 800", available: "24/7", type: "call", free: true },
    ],
  },
  GH: {
    country: "Ghana",
    flag: "🇬🇭",
    resources: [
      { name: "Mental Health Authority", number: "+233 302 776 351", available: "Mon-Fri 8am-5pm", type: "call", free: false },
      { name: "Befrienders Ghana", number: "+233 244 846 701", available: "24/7", type: "call", free: false },
    ],
  },
  EG: {
    country: "Egypt",
    flag: "🇪🇬",
    resources: [
      { name: "Egyptian Mental Health Hotline", number: "08008880700", available: "24/7", type: "call", free: true },
    ],
  },

  // ── Europe ──────────────────────────────────────────────────────────────────
  GB: {
    country: "United Kingdom",
    flag: "🇬🇧",
    resources: [
      { name: "Samaritans", number: "116 123", available: "24/7", type: "call", free: true },
      { name: "Crisis Text Line", number: "Text SHOUT to 85258", available: "24/7", type: "sms", free: true },
      { name: "Mind Infoline", number: "0300 123 3393", available: "Mon-Fri 9am-6pm", type: "call", free: false },
    ],
  },
  IE: {
    country: "Ireland",
    flag: "🇮🇪",
    resources: [
      { name: "Samaritans Ireland", number: "116 123", available: "24/7", type: "call", free: true },
      { name: "Crisis Text Line", number: "Text HELLO to 50808", available: "24/7", type: "sms", free: true },
    ],
  },
  DE: {
    country: "Germany",
    flag: "🇩🇪",
    resources: [
      { name: "Telefonseelsorge", number: "0800 111 0 111", available: "24/7", type: "call", free: true },
      { name: "Telefonseelsorge (alt)", number: "0800 111 0 222", available: "24/7", type: "call", free: true },
    ],
  },
  FR: {
    country: "France",
    flag: "🇫🇷",
    resources: [
      { name: "Numéro National Prévention Suicide", number: "3114", available: "24/7", type: "call", free: true },
      { name: "SOS Amitié", number: "09 72 39 40 50", available: "24/7", type: "call", free: false },
    ],
  },
  NL: {
    country: "Netherlands",
    flag: "🇳🇱",
    resources: [
      { name: "113 Suicide Prevention", number: "113", available: "24/7", type: "call", free: true },
      { name: "Sensoor", number: "0900 0767", available: "24/7", type: "call", free: false },
    ],
  },
  ES: {
    country: "Spain",
    flag: "🇪🇸",
    resources: [
      { name: "Teléfono de la Esperanza", number: "717 003 717", available: "24/7", type: "call", free: false },
      { name: "Crisis Line", number: "024", available: "24/7", type: "call", free: true },
    ],
  },
  IT: {
    country: "Italy",
    flag: "🇮🇹",
    resources: [
      { name: "Telefono Amico", number: "02 2327 2327", available: "Daily 10am-midnight", type: "call", free: false },
      { name: "Telefono Azzurro", number: "19696", available: "24/7", type: "call", free: true },
    ],
  },
  PT: {
    country: "Portugal",
    flag: "🇵🇹",
    resources: [
      { name: "SOS Voz Amiga", number: "213 544 545", available: "Daily 4pm-midnight", type: "call", free: false },
      { name: "Voz de Apoio", number: "225 506 070", available: "Daily 9pm-midnight", type: "call", free: false },
    ],
  },

  // ── Americas ─────────────────────────────────────────────────────────────────
  US: {
    country: "United States",
    flag: "🇺🇸",
    resources: [
      { name: "988 Suicide & Crisis Lifeline", number: "988", available: "24/7", type: "call", free: true },
      { name: "Crisis Text Line", number: "Text HOME to 741741", available: "24/7", type: "sms", free: true },
      { name: "NAMI Helpline", number: "1-800-950-6264", available: "Mon-Fri 10am-10pm ET", type: "call", free: true },
    ],
  },
  CA: {
    country: "Canada",
    flag: "🇨🇦",
    resources: [
      { name: "Talk Suicide Canada", number: "1-833-456-4566", available: "24/7", type: "call", free: true },
      { name: "Crisis Text Line", number: "Text HOME to 686868", available: "24/7", type: "sms", free: true },
    ],
  },
  BR: {
    country: "Brazil",
    flag: "🇧🇷",
    resources: [
      { name: "CVV (Centro de Valorização da Vida)", number: "188", available: "24/7", type: "call", free: true },
      { name: "CVV Chat", number: "cvv.org.br", available: "24/7", type: "chat", free: true },
    ],
  },
  MX: {
    country: "Mexico",
    flag: "🇲🇽",
    resources: [
      { name: "SAPTEL", number: "55 5259-8121", available: "24/7", type: "call", free: false },
      { name: "CONASAMA Crisis Line", number: "800 290 0024", available: "24/7", type: "call", free: true },
    ],
  },
  AR: {
    country: "Argentina",
    flag: "🇦🇷",
    resources: [
      { name: "Centro de Asistencia al Suicida", number: "135", available: "24/7", type: "call", free: true },
    ],
  },

  // ── Asia Pacific ─────────────────────────────────────────────────────────────
  AU: {
    country: "Australia",
    flag: "🇦🇺",
    resources: [
      { name: "Lifeline", number: "13 11 14", available: "24/7", type: "call", free: false },
      { name: "Beyond Blue", number: "1300 22 4636", available: "24/7", type: "call", free: false },
      { name: "Crisis Text Line", number: "Text HELLO to 0477 13 11 14", available: "24/7", type: "sms", free: true },
    ],
  },
  NZ: {
    country: "New Zealand",
    flag: "🇳🇿",
    resources: [
      { name: "Lifeline Aotearoa", number: "0800 543 354", available: "24/7", type: "call", free: true },
      { name: "Need to Talk", number: "1737", available: "24/7", type: "call", free: true },
    ],
  },
  IN: {
    country: "India",
    flag: "🇮🇳",
    resources: [
      { name: "iCall", number: "9152987821", available: "Mon-Sat 8am-10pm", type: "call", free: false },
      { name: "Vandrevala Foundation", number: "1860-2662-345", available: "24/7", type: "call", free: true },
      { name: "AASRA", number: "9820466627", available: "24/7", type: "call", free: false },
    ],
  },
  SG: {
    country: "Singapore",
    flag: "🇸🇬",
    resources: [
      { name: "Samaritans of Singapore", number: "1767", available: "24/7", type: "call", free: true },
      { name: "Crisis Text Line SG", number: "Text MindLine to 74747", available: "24/7", type: "sms", free: true },
    ],
  },
  JP: {
    country: "Japan",
    flag: "🇯🇵",
    resources: [
      { name: "Inochi no Denwa", number: "0120 783 556", available: "Daily 4pm-9pm", type: "call", free: true },
      { name: "TELL Lifeline", number: "03-5774-0992", available: "Daily 9am-11pm", type: "call", free: false },
    ],
  },
  CN: {
    country: "China",
    flag: "🇨🇳",
    resources: [
      { name: "Beijing Crisis Line", number: "010-82951332", available: "24/7", type: "call", free: false },
      { name: "Shanghai Mental Health", number: "021-12320-5", available: "24/7", type: "call", free: false },
    ],
  },

  // ── Middle East ───────────────────────────────────────────────────────────────
  AE: {
    country: "UAE",
    flag: "🇦🇪",
    resources: [
      { name: "Dubai Wellbeing Hotline", number: "800 4673", available: "24/7", type: "call", free: true },
      { name: "Abu Dhabi Crisis Line", number: "800 HOPE (4673)", available: "24/7", type: "call", free: true },
    ],
  },
  SA: {
    country: "Saudi Arabia",
    flag: "🇸🇦",
    resources: [
      { name: "KSA Mental Health Line", number: "920033360", available: "24/7", type: "call", free: true },
    ],
  },
};

// ─── International fallback ───────────────────────────────────────────────────
export const INTERNATIONAL_RESOURCES = {
  country: "International",
  flag: "🌍",
  resources: [
    { name: "Befrienders Worldwide", number: "befrienders.org", available: "24/7", type: "chat", free: true },
    { name: "International Association for Suicide Prevention", number: "iasp.info/resources/Crisis_Centres", available: "24/7", type: "chat", free: true },
    { name: "Crisis Text Line (US/UK/CA/IE)", number: "Text HOME to 741741", available: "24/7", type: "sms", free: true },
  ],
};

// ─── Get resources for a country code ────────────────────────────────────────
export function getResourcesForCountry(countryCode) {
  if (!countryCode) return INTERNATIONAL_RESOURCES;
  return CRISIS_RESOURCES[countryCode.toUpperCase()] || INTERNATIONAL_RESOURCES;
}

// ─── Detect country from IP (free service) ───────────────────────────────────
export async function detectCountry() {
  try {
    const res = await fetch("https://ipapi.co/json/");
    const data = await res.json();
    return {
      countryCode: data.country_code || null,
      countryName: data.country_name || null,
      city: data.city || null,
      language: data.languages?.split(",")?.[0]?.split("-")?.[0] || "en",
    };
  } catch {
    return { countryCode: null, countryName: null, city: null, language: "en" };
  }
}
